export default "__VITE_ASSET__BqWs4BUh__"